import { lazyGetCopilotReplyWithMeetingSections } from 'owa-mail-ribbon-sections/lib/sections';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';
import { logUsage } from 'owa-analytics';
import getActionSourceFromCommandingViewMode from 'owa-command-ribbon/lib/util/getActionSourceFromCommandingViewMode';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';

export const onCopilotReplyWithMeetingMenuClicked = (
    props: ReadOnlyRibbonControlDefProps
): void => {
    const actionSource = getActionSourceFromCommandingViewMode();
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);

    logUsage('CopilotReplyWithMeeting_FlyoutOpened', mailboxInfo, { actionSource });
    lazyGetCopilotReplyWithMeetingSections.import().then(getSections => {
        setMenuDefinition('CopilotMeetingMenuDefinitionStore', props.projectionTabId, () => {
            return {
                sections: getSections(props),
            };
        });
    });
};
